"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AppOrder {
}
exports.default = AppOrder;
//# sourceMappingURL=AppOrder.js.map